import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { containerReducer } from 'src/containers/ContainerSlice';
import { auth0UserManagementReducer } from 'src/views/admins/auth0/UserManagementSlice';

export const store = configureStore({
  reducer: {
    container: containerReducer,
    auth0UserManagement: auth0UserManagementReducer
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useStoreSelector: TypedUseSelectorHook<RootState> = useSelector;

